var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',[_c('Jumbo',{attrs:{"wpFields":_vm.wpFields.acf}})],1),_c('div',{attrs:{"id":"topSec"}},[_c('TopSec',{attrs:{"wpFields":_vm.wpFields.acf}}),_c('Services')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }